import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    setError(null);
    setMessage(null);

    try {
      const response = await api.post('/auth/forgot-password', { email: email.trim() });
      setMessage('Password reset instructions have been sent to your email address.');
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const onChange = (e) => {
    setEmail(e.target.value);
    // Clear errors when user starts typing
    if (error) setError(null);
    if (message) setMessage(null);
  };

  return (
    <div className="form-container">
      <div className="form-header">
        <h1 className="form-title">Reset Your Password</h1>
        <p className="form-subtitle">
          Enter your email address and we'll send you instructions to reset your password
        </p>
      </div>

      {message && (
        <div className="alert alert--success">
          <strong>Email Sent!</strong> {message}
          <div className="mt-2">
            <small className="text-muted">
              Check your spam folder if you don't see the email in your inbox.
            </small>
          </div>
        </div>
      )}

      {error && (
        <div className="alert alert--error">
          <strong>Error:</strong> {error}
        </div>
      )}

      {!message && (
        <form onSubmit={onSubmit} noValidate>
          <div className="form-group">
            <label htmlFor="email" className="form-label form-label--required">
              Email Address
            </label>
            <div className="form-input-group">
              <span className="form-input-icon">📧</span>
              <input
                type="email"
                id="email"
                name="email"
                className={`form-input form-input--with-icon ${error ? 'form-input--error' : ''}`}
                value={email}
                onChange={onChange}
                placeholder="Enter your registered email address"
                required
                autoComplete="email"
                disabled={loading}
              />
            </div>
            <small className="text-muted">
              We'll send password reset instructions to this email
            </small>
          </div>

          <button
            type="submit"
            className={`btn btn--primary btn--full ${loading ? 'btn--loading' : ''}`}
            disabled={loading || !email.trim()}
          >
            {loading ? '' : 'Send Reset Instructions'}
          </button>

          <div className="form-group mt-3 text-center">
            <Link to="/login" className="link link--muted">
              ← Back to Login
            </Link>
          </div>

          <div className="form-group text-center">
            <p className="text-secondary">
              Remember your password?{' '}
              <Link to="/login" className="link">
                Sign in here
              </Link>
            </p>
          </div>
        </form>
      )}

      {message && (
        <div className="text-center mt-4">
          <Link to="/login" className="btn btn--outline">
            Return to Login
          </Link>
        </div>
      )}

      <div className="mt-4 text-center">
        <p className="text-muted text-sm">
          Need help? Contact our support team for assistance
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
